import { useStore } from '../js/store';
import { pathOr } from '../js/utilities';
import { track } from 's2s-app-service';
import {
    LS_SECTION_KEYS,
    storeLocalData,
    retrieveLocalData,
} from './../js/localData';

const LS_SECTION_KEY = LS_SECTION_KEYS.SETTINGS;

const ringTones = [
  { 'value': '/assets/sounds/bell_ring2.wav', 'label': 'Bell' },
  { 'value': '/assets/sounds/warble.wav', 'label': 'Warble' }
];

const ringBacks = [
  { 'value': '/assets/sounds/Australia_ringing_tone.ogg', 'label': 'Australian' },
  { 'value': '/assets/sounds/europe_ringback.ogg', 'label': 'Europe' },
  { 'value': '/assets/sounds/JA_Ringback_tone.ogg', 'label': 'Japan' },
  { 'value': '/assets/sounds/UK_ringback_tone.ogg', 'label': 'United Kingdom' },
  { 'value': '/assets/sounds/US_ringback_tone.ogg', 'label': 'United States' },
];

const viewAlerts = [
  { 'value': 'view', 'label': 'View' },
  { 'value': 'email', 'label': 'Email' },
  { 'value': 'download', 'label': 'Download' },
];

const DEFAULT_SETTINGS = {
  'alwaysontop': false,
  'advancedLogging': undefined,
  "ringBacks": ringBacks,
  "ringTones": ringTones,
  "viewAlerts": viewAlerts,
  "outputVolume": 1,
  "selectedRingBack": '/assets/sounds/US_ringback_tone.ogg', // default to United States
  "selectedRingTone": ringTones[0].value,
  "selectedViewAlerts": {},
  "selectedAudio": {},
  "selectedSpeaker": {}
};

// Merging default settings and settings loaded from LS.
const initialState = {
  ...DEFAULT_SETTINGS,
  ...retrieveLocalData(LS_SECTION_KEY, Object.assign({}, {})),
};

// Remove selectedViewAlert's value for new loading, it must be undefined 
if (initialState.selectedViewAlerts) {
  initialState.selectedViewAlerts = {};
}

// Updating stored settings.
storeLocalData(LS_SECTION_KEY, initialState);
//The following settings items from the old softphone are not present here: selectedTheme, themes, languages, selectedLanguage

const useSettings = () => {
  const [state, setState] = useStore();
  const changeSettings = (settingsData) => {
    track("settings", "changed", settingsData);
    //eslint-disable-next-line no-undef
    if(settingsData?.alwaysontop !== undefined && typeof window.setAlwaysOnTop === "function"){
      window.setAlwaysOnTop(typeof settingsData.alwaysontop === "boolean" ? settingsData.alwaysontop : false);
    }
    return setState((state) => {
      const newState = {
        ...state,
        settings: {
          ...state.settings,
          ...settingsData,
        },
      };

      storeLocalData(LS_SECTION_KEY, newState.settings);

      return newState;
    });
  };

  
  const setWSGLogs = (data) => {
    // Update state.settings by WSG logs
    return setState(state => {
      if (data) {
        return {
          ...state,
          settings: {
            ...state.settings,
            wsgLogs: data,
          }
        };
      } else {
        const stateCopy = Object.assign({}, state);
        delete stateCopy.settings.wsgLogs;
        return stateCopy;
      }
    });
  };

  const settingsReturn = state && state.settings ? state.settings : initialState;

  return [
    settingsReturn, { changeSettings, setWSGLogs }
  ];
};

export default useSettings;
export { initialState };
